import React from "react"
import { useIntl, Link } from "gatsby-plugin-intl"
import { StaticImage } from "gatsby-plugin-image"
import Menu from "./Menu.js"

export default function Footer() {
  const intl = useIntl()
  return (
    <footer>
      <section className="extraContent">
        <div className="extraContent--container">
          <div className="extraContent--main">
            <div className="partners">
              <div className="partners__logo">
                <a href="https://www.parisandco.paris/">
                  <StaticImage
                    className="partners__logo--elmt"
                    src="../images/partners-logo/logo-parisandco_orange.png"
                    alt="Paris & Co"
                    placeholder="blurred"
                    layout="constrained"
                    transformOptions={{
                      fit: "contain",
                      cropFocus: "attention",
                    }}
                    objectFit="contain"
                  />
                </a>
              </div>

              <div className="partners__logo">
                <a href="http://lesapprimeurs.com/">
                  <StaticImage
                    className="partners__logo--elmt"
                    src="../images/partners-logo/apprimeurs.png"
                    alt="Les Apprimeurs"
                    placeholder="blurred"
                    layout="constrained"
                    transformOptions={{
                      fit: "contain",
                      cropFocus: "attention",
                    }}
                    objectFit="contain"
                  />
                </a>
              </div>

              <div className="partners__logo">
                <a href="https://domspain.es/en/home">
                  <StaticImage
                    className="partners__logo--elmt"
                    src="../images/partners-logo/domspain.png"
                    alt="Domspain"
                    placeholder="blurred"
                    layout="constrained"
                    transformOptions={{
                      fit: "contain",
                      cropFocus: "attention",
                    }}
                    objectFit="contain"
                  />
                </a>
              </div>

              <div className="partners__logo">
                <a href="https://logopsycom.com/">
                  <StaticImage
                    className="partners__logo--elmt"
                    src="../images/partners-logo/logopsycom.png"
                    alt="Logopsycom"
                    placeholder="blurred"
                    layout="constrained"
                    transformOptions={{
                      fit: "contain",
                      cropFocus: "attention",
                    }}
                    objectFit="contain"
                  />
                </a>
              </div>

              <div className="partners__logo">
                <a href="https://nikanor.bg/en/">
                  <StaticImage
                    className="partners__logo--elmt"
                    src="../images/partners-logo/nikanor.png"
                    alt="Nikanor"
                    placeholder="blurred"
                    layout="constrained"
                    transformOptions={{
                      fit: "contain",
                      cropFocus: "attention",
                    }}
                    objectFit="contain"
                  />
                </a>
              </div>

              <div className="partners__logo">
                <a href="https://istitutosorditorino.org/">
                  <StaticImage
                    className="partners__logo--elmt"
                    src="../images/partners-logo/LogoIST PNG.png"
                    alt="IST"
                    placeholder="blurred"
                    layout="constrained"
                    transformOptions={{
                      fit: "contain",
                      cropFocus: "attention",
                    }}
                    objectFit="contain"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="extraContent">
        <div className="extraContent--container">
          <div className="extraContent--main">
            <div className="erasmusPlus">
              <div className="erasmusPlus--logo">
                <StaticImage
                  className="partners__logo--elmt"
                  src="../images/erasmus-logo.png"
                  alt="Paris & Co"
                  placeholder="blurred"
                  layout="constrained"
                  transformOptions={{ fit: "contain", cropFocus: "attention" }}
                  objectFit="contain"
                />
              </div>
              <div className="erasmusPlus--text">
                <p>{intl.formatMessage({ id: "menu21" })}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Menu ariaLabel={intl.formatMessage({ id: "accessibility4" })} />
      <section className="extraContent gradientBackground">
        <div className="extraContent--container">
          <div className="extraContent--main footerContainer">
            <div className="ecoindex">
              <p>{intl.formatMessage({ id: "menu26" })}: A</p>
              <p>{intl.formatMessage({ id: "menu26" })}: 84</p>
              <p>{intl.formatMessage({ id: "menu27" })}: 1.98</p>
              <p>{intl.formatMessage({ id: "menu28" })}: 1.32</p>
              <p>
                <a href="http://ecoindex.fr/">
                  {intl.formatMessage({ id: "menu34" })}
                </a>
              </p>
            </div>

            <div className="footerMentions">
              <p className="footerMentions__copyright">
                © 2021 - The Good Manager&nbsp;
                <a href="https://en.wikipedia.org/wiki/Creative_Commons_license">
                  <img
                    src="/creativecommons.svg"
                    alt="The Good Manager"
                    style={{
                      height: "1.5rem",
                      paddingRight: "0.3rem",
                      verticalAlign: "middle",
                    }}
                  />
                  CC-BY-SA 4.0
                </a>
              </p>
              <nav
                className="footerNav"
                aria-label={intl.formatMessage({ id: "menu15" })}
              >
                <ul>
                  <li>
                    <Link to="/legal">
                      {intl.formatMessage({ id: "menu15" })}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-policy">
                      {intl.formatMessage({ id: "menu32" })}
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}
